/* Elara — sync the product price block to the selected Bundler tier.
   Bundler updates the main sale price when a bundle is chosen but leaves the
   strikethrough (compare-at) and the "% OFF" badge stale, which is the bug that
   showed a $126 price struck from $115. This watches the sale price and rewrites
   the compare-at + badge to match, everything measured against the real former
   price of $115 per unit. Only runs on the product page (needs <product-price>). */
(function () {
  'use strict';

  // Selected bundle sale price -> compare-at (struck) total and badge text.
  // Base $62/brush, 20% off 2+. Bundle badges show the % saved.
  var TIERS = [
    { total: 62,    compare: 95,  badge: '35% OFF' },
    { total: 99.2,  compare: 124, badge: 'SAVE 20%' },
    { total: 148.8, compare: 186, badge: 'SAVE 20%' }
  ];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function visibleText(el) {
    if (!el) return '';
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var node, out = '';
    while ((node = walker.nextNode())) {
      if (node.parentElement && node.parentElement.closest('.visually-hidden')) continue;
      out += node.nodeValue;
    }
    return out.trim();
  }

  function toNumber(str) {
    if (!str) return NaN;
    return parseFloat(String(str).replace(/[^0-9.]/g, ''));
  }

  function money(prefix, value) {
    var parts = value.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return prefix + parts.join('.');
  }

  function findTier(value) {
    for (var i = 0; i < TIERS.length; i++) {
      if (Math.abs(value - TIERS[i].total) < 0.6) return TIERS[i];
    }
    return null;
  }

  function findBadge() {
    var els = document.querySelectorAll('body *');
    var found = null;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest('[class*="bundler" i]')) continue;
      if (/^\d+%\s*OFF$/i.test((el.textContent || '').trim())) found = el;
    }
    return found;
  }

  function setBadgeText(el, txt) {
    if (!el) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var node, target = null;
    while ((node = walker.nextNode())) {
      if (/\d+%|OFF|SAVE/i.test(node.nodeValue)) target = node;
    }
    if (target) {
      if (target.nodeValue.trim() !== txt) target.nodeValue = txt;
    } else if (el.textContent.trim() !== txt) {
      el.textContent = txt;
    }
  }

  function sync(container) {
    var priceEl = container.querySelector('.price');
    var compareEl = container.querySelector('.compare-at-price');
    if (!priceEl) return;

    var priceText = visibleText(priceEl);
    var value = toNumber(priceText);
    if (isNaN(value)) return;

    var tier = findTier(value);
    if (!tier) return;

    var prefix = (priceText.match(/^[^\d]*/) || [''])[0];

    if (compareEl) {
      var hidden = compareEl.querySelector('.visually-hidden');
      var desired = (hidden ? hidden.outerHTML : '') + money(prefix, tier.compare);
      if (compareEl.innerHTML.replace(/\s+/g, '') !== desired.replace(/\s+/g, '')) {
        compareEl.innerHTML = desired;
      }
      compareEl.style.removeProperty('display');
    }

    setBadgeText(window.__elaraBadge || (window.__elaraBadge = findBadge()), tier.badge);
  }

  function init() {
    var container = document.querySelector('product-price');
    if (!container || !container.querySelector('.price')) return false;

    window.__elaraBadge = findBadge();

    var run = function () { sync(container); };
    run();

    var obs = new MutationObserver(run);
    obs.observe(container, { childList: true, characterData: true, subtree: true });
    return true;
  }

  ready(function () {
    if (init()) return;
    var tries = 0;
    var t = setInterval(function () {
      if (init() || ++tries > 40) clearInterval(t);
    }, 250);
  });
})();

/* Elara — replace the product description block with a compact feature grid
   (small line-art icons in blush circles). Runs from custom.js because the theme
   editor reverts template (JSON) edits; assets are safe. The description text
   stays in the template for SEO; shoppers see the grid. Horizon can generate a
   different block id at render time than the template key, so we find the
   description block by its CONTENT, not by a fixed class. */
(function () {
  'use strict';

  var ICONS = {
    light: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3.6"/><path d="M12 2.4v2.2M12 19.4v2.2M4.6 4.6l1.5 1.5M17.9 17.9l1.5 1.5M2.4 12h2.2M19.4 12h2.2M4.6 19.4l1.5-1.5M17.9 6.1l1.5-1.5"/></svg>',
    oil: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3s6 6.4 6 10.4A6 6 0 0 1 6 13.4C6 9.4 12 3 12 3z"/></svg>',
    massage: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13.5a7 7 0 0 1 14 0"/><path d="M3.8 16.8h16.4"/><path d="M8.4 9.6c.7-.9 1.6-.9 2.3 0M13.3 9.6c.7-.9 1.6-.9 2.3 0"/></svg>',
    moon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z"/></svg>',
    battery: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="15" height="8" rx="2"/><path d="M21 11v2"/><path d="M11 9.3 9 12.6h2.6L9.6 15.7"/></svg>'
  };

  var ITEMS = [
    ['light', 'Red Light'],
    ['oil', 'Oil Infusion'],
    ['massage', 'Scalp Massage'],
    ['moon', 'Nightly Ritual'],
    ['battery', 'Rechargeable']
  ];

  function buildGrid() {
    var html = '<div class="elara-features">';
    for (var i = 0; i < ITEMS.length; i++) {
      html += '<div class="elara-feature"><span class="elara-feature__icon">' +
        ICONS[ITEMS[i][0]] + '</span><span>' + ITEMS[i][1] + '</span></div>';
    }
    return html + '</div>';
  }

  function findDescBlock() {
    var byClass = document.querySelector('.text-block--text_aEtTtq');
    if (byClass) return byClass;
    var blocks = document.querySelectorAll('.text-block, [class*="text-block"], .rte');
    for (var i = 0; i < blocks.length; i++) {
      if (/Five minutes to yourself/i.test(blocks[i].textContent || '')) return blocks[i];
    }
    // Last resort: deepest element holding both the first and last feature text.
    var all = document.querySelectorAll('body *');
    var hit = null;
    for (var j = 0; j < all.length; j++) {
      var tc = all[j].textContent || '';
      if (/Five minutes to yourself/i.test(tc) && /Rechargeable/i.test(tc)) hit = all[j];
    }
    return hit;
  }

  function inject() {
    var el = findDescBlock();
    if (!el) return false;
    if (el.getAttribute('data-elara-grid') !== '1') {
      el.innerHTML = buildGrid();
      el.setAttribute('data-elara-grid', '1');
    }
    return true;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (inject()) return;
    var n = 0, t = setInterval(function () { if (inject() || ++n > 40) clearInterval(t); }, 250);
  });
})();

/* Elara — reviews under the buy area (right column, clear of the sticky gallery).
   Style: gold stars + name + statement, no photo, dots to switch. Fill in name /
   text as friends respond. */
(function () {
  'use strict';

  var REVIEWS = [
    { name: 'Chloe', rating: 5, text: 'I love this brush! The massaging bristles feel so soothing on my scalp, and I love that it dispenses oil while using the red light. It makes my hair care routine feel so much easier and relaxing.' },
    { name: 'Arianna', rating: 4.8, text: 'Really happy with this brush! The red light has worked so well for me, and I love how simple it is to fit into my routine.' },
    { name: 'Maryam', rating: 5, text: 'The oil dispenser is probably my favourite part. It makes applying hair oil so much easier and way less messy than doing it by hand.' },
    { name: 'Maya', rating: 5, text: 'I mainly got this for the massage feature and I\'m so glad I did. The bristles feel gentle but still give a really nice scalp massage without being uncomfortable.' }
  ];

  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function build() {
    var box = document.createElement('div');
    box.className = 'elara-reviews';
    box.innerHTML =
      '<div class="elara-reviews__head">' +
        '<span class="elara-reviews__stars"><span class="elara-reviews__stars-fill">★★★★★</span>★★★★★</span>' +
        '<span class="elara-reviews__name"></span>' +
      '</div>' +
      '<p class="elara-reviews__text"></p>' +
      '<div class="elara-reviews__controls"><button class="elara-reviews__nav elara-reviews__prev" type="button" aria-label="Previous review">‹</button><div class="elara-reviews__dots"></div><button class="elara-reviews__nav elara-reviews__next" type="button" aria-label="Next review">›</button></div>';

    var idx = 0;
    var nameEl = box.querySelector('.elara-reviews__name');
    var starsFill = box.querySelector('.elara-reviews__stars-fill');
    var textEl = box.querySelector('.elara-reviews__text');
    var dots = box.querySelector('.elara-reviews__dots');

    for (var d = 0; d < REVIEWS.length; d++) {
      var dot = document.createElement('span');
      dot.className = 'elara-reviews__dot';
      (function (i) { dot.addEventListener('click', function () { idx = i; render(); }); })(d);
      dots.appendChild(dot);
    }

    function render() {
      var r = REVIEWS[idx];
      if (starsFill) starsFill.style.width = ((r.rating || 5) / 5 * 100) + '%';
      nameEl.textContent = r.name || '';
      nameEl.style.display = r.name ? '' : 'none';
      textEl.innerHTML = r.text ? '“' + esc(r.text) + '”' : '';
      textEl.style.display = r.text ? '' : 'none';
      var ds = dots.children;
      for (var i = 0; i < ds.length; i++) ds[i].className = 'elara-reviews__dot' + (i === idx ? ' elara-reviews__dot--active' : '');
    }
    function go(n) { idx = (idx + n + REVIEWS.length) % REVIEWS.length; render(); }
    box.querySelector('.elara-reviews__prev').addEventListener('click', function () { go(-1); });
    box.querySelector('.elara-reviews__next').addEventListener('click', function () { go(1); });
    // Swipe / drag through reviews (touch + mouse), keeping the arrows and dots.
    var sx = null, sy = null, dragging = false;
    function swStart(e) { var p = e.touches ? e.touches[0] : e; sx = p.clientX; sy = p.clientY; dragging = true; }
    function swEnd(e) {
      if (!dragging || sx === null) { dragging = false; return; }
      dragging = false;
      var p = e.changedTouches ? e.changedTouches[0] : e;
      var dx = p.clientX - sx, dy = p.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) go(dx < 0 ? 1 : -1);
      sx = sy = null;
    }
    box.addEventListener('touchstart', swStart, { passive: true });
    box.addEventListener('touchend', swEnd);
    box.addEventListener('mousedown', swStart);
    box.addEventListener('mouseup', swEnd);
    box.style.touchAction = 'pan-y';
    // Lock every slide to the height of the tallest one so the box never resizes.
    box._equalize = function () {
      box.style.minHeight = '';
      var mh = 0, cur = idx;
      for (var i = 0; i < REVIEWS.length; i++) { idx = i; render(); if (box.offsetHeight > mh) mh = box.offsetHeight; }
      idx = cur; render();
      box.style.minHeight = mh + 'px';
    };
    render();
    return box;
  }

  function inject() {
    if (document.querySelector('.elara-reviews')) return true;
    var anchor = document.querySelector('.buy-buttons-block') ||
                 document.querySelector('.elara-payment-icons');
    if (!anchor) return false;
    var box = build();
    anchor.insertAdjacentElement('afterend', box);
    var eq = function () { box._equalize(); };
    eq();
    if (document.readyState !== 'complete') window.addEventListener('load', eq);
    var to; window.addEventListener('resize', function () { clearTimeout(to); to = setTimeout(eq, 120); });
    return true;
  }

  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    if (inject()) return;
    var n = 0, t = setInterval(function () { if (inject() || ++n > 40) clearInterval(t); }, 250);
  });
})();

/* Elara — "+ GIFT" labels on the 2- and 3-brush bundle tiers (guide book, both versions) */
(function () {
  'use strict';
  var TIER_TEXTS = ['2 Elara Brush', '3 Elara Brush'];
  var GIFTS = ['30-Day Ritual Guide'];

  // Deepest element that contains the tier label AND a radio = the tier box.
  function tierBox(text) {
    var els = document.querySelectorAll('body *');
    var found = null;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if ((el.textContent || '').indexOf(text) > -1 &&
          el.querySelector('input[type="radio"],input[type="checkbox"]')) found = el;
    }
    return found;
  }

  function outerBox(text) {
    var inner = tierBox(text);
    if (!inner) return null;
    return inner.closest('[class*="option" i], label') || inner;
  }

  function addGifts() {
    var placed = 0;
    for (var i = 0; i < TIER_TEXTS.length; i++) {
      var box = outerBox(TIER_TEXTS[i]);
      if (!box) continue;
      var nx = box.nextElementSibling;
      if (nx && nx.classList && nx.classList.contains('elara-gift-wrap')) { placed++; continue; }
      box.classList.add('elara-gifted');
      var wrap = document.createElement('div');
      wrap.className = 'elara-gift-wrap';
      wrap.innerHTML = '<div class="elara-gift-row"><span class="elara-gift-tag">+ GIFT</span>' +
                       '<span class="elara-gift-txt">' + GIFTS[0] + '</span></div>';
      var cs = getComputedStyle(box);          // match the pill's exact width + spacing
      wrap.style.marginLeft = cs.marginLeft;
      wrap.style.marginRight = cs.marginRight;
      wrap.style.marginTop = '-16px';
      wrap.style.marginBottom = cs.marginBottom;
      box.insertAdjacentElement('afterend', wrap);
      placed++;
    }
    return placed >= TIER_TEXTS.length;
  }

  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function () {
    var n = 0, t = setInterval(function () { if (addGifts() || ++n > 60) clearInterval(t); }, 300);
  });
})();

/* Elara — "Free shipping" line under each bundle tier name (Bundler paywalls this) */
(function () {
  'use strict';
  var NAMES = ['Elara Brush', '2 Elara Brushes', '3 Elara Brushes'];
  function nameLeaf(txt) {
    var els = document.querySelectorAll('body *');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el.querySelector('*') && (el.textContent || '').trim() === txt) return el;
    }
    return null;
  }
  function add() {
    var done = 0;
    for (var i = 0; i < NAMES.length; i++) {
      var el = nameLeaf(NAMES[i]);
      if (!el) continue;
      var box = el.closest('.bndlr-radio-container') || el.closest('label');
      if (!box) continue;
      if (box.querySelector('.elara-freeship-r')) { done++; continue; }
      var fs = document.createElement('div');
      fs.className = 'elara-freeship-r';
      fs.textContent = 'Free shipping';
      box.appendChild(fs);
      done++;
    }
    return done >= NAMES.length;
  }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function () { var n=0,t=setInterval(function(){ if(add()||++n>60) clearInterval(t); },300); });
})();

/* Elara — small product thumbnail on each bundle tier (1 / 2 / 3 brushes) */
(function () {
  'use strict';
  var IMGS = {
    'Elara Brush': 'elara-tier-1.png',
    '2 Elara Brushes': 'elara-tier-2.png',
    '3 Elara Brushes': 'elara-tier-3.png'
  };
  function assetBase() {
    var list = document.querySelectorAll('script[src*="/custom.js"]');
    var me = list[list.length - 1];
    return me ? me.src.split('custom.js')[0] : '';
  }
  function nameLeaf(txt) {
    var els = document.querySelectorAll('body *');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el.querySelector('*') && (el.textContent || '').trim() === txt) return el;
    }
    return null;
  }
  function add() {
    var base = assetBase();
    if (!base) return false;
    var done = 0, total = 0;
    for (var name in IMGS) {
      total++;
      var el = nameLeaf(name);
      if (!el) continue;
      var row = el.closest('label') || el.parentNode;
      if (!row) continue;
      if (row.querySelector('.elara-tier-img')) { done++; continue; }
      var img = document.createElement('img');
      img.className = 'elara-tier-img';
      img.src = base + IMGS[name];
      img.alt = '';
      row.insertBefore(img, row.firstChild);
      done++;
    }
    return done >= total;
  }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function () { var n=0,t=setInterval(function(){ if(add()||++n>60) clearInterval(t); },300); });
})();

/* Elara — FAQ accordion under the reviews (right column, buy area) */
(function () {
  'use strict';
  var S = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"';
  var PLANE = '<svg '+S+'><path d="M2 12l19-8-8 19-2.5-8.5L2 12z"/></svg>';
  var BOX   = '<svg '+S+'><path d="M21 8 12 3 3 8v8l9 5 9-5V8z"/><path d="M3 8l9 5 9-5"/><path d="M12 13v8"/></svg>';
  var UNDO  = '<svg '+S+'><path d="M9 14 4 9l5-5"/><path d="M4 9h11a5 5 0 0 1 0 10h-2"/></svg>';
  var CHEV  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';

  var FAQ = [
    { icon: PLANE, q: "How long will my order take to arrive?",
      a: "Europe: 6–12 business days.<br>North America: 8–15 business days.<br>Oceania: 5–10 days.<br>Asia: 2–10 business days.<br><br>Shipping time may be slightly extended due to customs inspections, extreme weather, and other factors outside our control." },
    { icon: BOX, q: "What does my order include?",
      a: "Every order includes your Elara Red Light Brush and a USB charging cable — everything you need to get started, with nothing to replace." },
    { icon: UNDO, q: "Can I return it if I’m not satisfied?",
      a: "Yes. If it’s not for you, send it back within 30 days of delivery — unused and in its original packaging — and we’ll refund you. Full details are in our refund policy." }
  ];

  function build() {
    var box = document.createElement('div');
    box.className = 'elara-faq';
    var html = '';
    for (var i = 0; i < FAQ.length; i++) {
      html += '<div class="elara-faq__item">' +
        '<button class="elara-faq__q" type="button">' +
          '<span class="elara-faq__icon">' + FAQ[i].icon + '</span>' +
          '<span class="elara-faq__qt">' + FAQ[i].q + '</span>' +
          '<span class="elara-faq__chev">' + CHEV + '</span>' +
        '</button>' +
        '<div class="elara-faq__a"><div class="elara-faq__inner">' + FAQ[i].a + '</div></div>' +
      '</div>';
    }
    box.innerHTML = html;
    box.querySelectorAll('.elara-faq__q').forEach(function (q) {
      q.addEventListener('click', function () { q.parentNode.classList.toggle('open'); });
    });
    return box;
  }

  function inject() {
    if (document.querySelector('.elara-faq')) return true;
    var anchor = document.querySelector('.elara-reviews');
    if (!anchor) return false;
    anchor.insertAdjacentElement('afterend', build());
    return true;
  }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function () { var n=0,t=setInterval(function(){ if(inject()||++n>60) clearInterval(t); },300); });
})();

/* Elara — FAQ accordion, full-width, at the bottom under the review sliders.
   One consolidated FAQ (replaces the old right-column 3-question one). First
   item open by default. Product page only. Answers stay cosmetic/experience —
   no growth, density, follicle or therapy claims. */
(function () {
  'use strict';
  var CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';

  var FAQ = [
    { q: "Does it really work, or is it just another fad?",
      a: "It’s built around three things your scalp actually responds to: a gentle ring of warm red light, soft massaging bristles, and a refillable tank that works your own oil through your hair as you brush. It won’t perform miracles overnight, and we won’t pretend it will. What it does is turn five minutes of scalp care into something you’ll actually look forward to — and with consistent use, most people love how much healthier and fuller their hair looks and feels." },
    { q: "How do I use it, and how long until I notice a difference?",
      a: "Use it on dry or towel-dried hair for about five minutes, a few times a week. Fill the tank with your favourite hair oil, switch it on, and glide it slowly across your scalp. Most people love the relaxing massage from the very first use. For how your hair looks and feels, give it consistent use over a few weeks — like any good routine, it rewards showing up." },
    { q: "Is the red light safe to use on my scalp?",
      a: "Yes. It uses a gentle, low-level warm red light made for comfortable everyday use — no burning and no harsh heat. Keep it moving slowly across your scalp as directed and it stays completely comfortable. If you have a medical scalp condition or any concerns, check with your doctor first." },
    { q: "Can I use it on colour-treated or sensitive hair, and with my own products?",
      a: "Absolutely. The brush is gentle enough for colour-treated and sensitive hair, and it’s built to work with the products you already use — just fill the tank with a light hair oil or serum and it spreads it evenly as you brush. Start with a small amount; a little goes a long way." },
    { q: "What’s included, and what if it’s not for me?",
      a: "Every order includes your Elara Red Light Brush and a USB charging cable — it’s rechargeable, so there’s nothing to replace. Shipping is free, and delivery usually takes 8–15 business days in North America (6–12 in Europe). If it’s not for you, send it back within 30 days, unused and in its original packaging, for a refund. Full details are in our refund policy." }
  ];

  function build() {
    var sec = document.createElement('section');
    sec.className = 'elara-faq2';
    var html = '<h2 class="elara-faq2__title">FAQ</h2><div class="elara-faq2__list">';
    for (var i = 0; i < FAQ.length; i++) {
      html += '<div class="elara-faq2__item' + (i === 0 ? ' open' : '') + '">' +
        '<button class="elara-faq2__q" type="button">' +
          '<span class="elara-faq2__qt">' + FAQ[i].q + '</span>' +
          '<span class="elara-faq2__chev">' + CHEV + '</span>' +
        '</button>' +
        '<div class="elara-faq2__a"><div class="elara-faq2__inner">' + FAQ[i].a + '</div></div>' +
      '</div>';
    }
    html += '</div>';
    sec.innerHTML = html;
    sec.querySelectorAll('.elara-faq2__q').forEach(function (q) {
      q.addEventListener('click', function () { q.parentNode.classList.toggle('open'); });
    });
    return sec;
  }

  function inject() {
    if (document.querySelector('.elara-faq2')) return true;
    var anchor = document.querySelector('.elara-r3wrap'); // bottom before/after section only, never the buy-box reviews
    if (!anchor) return false;
    anchor.insertAdjacentElement('afterend', build());
    return true;
  }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function () { if (!/\/products\//.test(location.pathname)) return; var n=0,t=setInterval(function(){ if(inject()||++n>60) clearInterval(t); },300); });
})();

/* Elara — scrolling "Real hair, Real results" marquee above the email-list section */
(function () {
  'use strict';
  function build() {
    var wrap = document.createElement('div');
    wrap.className = 'elara-marquee';
    var track = document.createElement('div');
    track.className = 'elara-marquee__track';
    var unit = '<span>Real hair, real results</span>';
    var html = '';
    for (var i = 0; i < 16; i++) html += unit;
    track.innerHTML = html;
    wrap.appendChild(track);
    return wrap;
  }
  function target() {
    if (document.querySelector('.elara-marquee')) return null;
    var all = document.querySelectorAll('body *');
    for (var i = 0; i < all.length; i++) {
      if (!all[i].querySelector('*') && /Join our email list/i.test(all[i].textContent || '')) {
        return all[i].closest('.shopify-section') || all[i];
      }
    }
    return null;
  }
  function inject() {
    if (document.querySelector('.elara-marquee')) return true;
    var t = target();
    if (!t) return false;
    t.insertAdjacentElement('beforebegin', build());
    return true;
  }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function () { if (!/\/products\//.test(location.pathname)) return; var n=0,tm=setInterval(function(){ if(inject()||++n>60) clearInterval(tm); },300); });
})();

/* Elara — UGC video conveyor under the text marquee, scrolling the opposite way */
(function () {
  'use strict';
  var N = 7;

  function openModal(src) {
    if (!src) return;
    var ov = document.createElement('div');
    ov.className = 'elara-vmodal';
    ov.innerHTML = '<button class="elara-vmodal__close" type="button" aria-label="Close">&times;</button><div class="elara-vmodal__stage"><video src="' + src + '" controls autoplay playsinline></video></div>';
    document.body.appendChild(ov);
    document.body.style.overflow = 'hidden';
    var vid = ov.querySelector('video');
    vid.muted = false;
    var pr = vid.play(); if (pr && pr.catch) pr.catch(function () { vid.muted = true; vid.play(); });
    function close() { ov.remove(); document.body.style.overflow = ''; document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    ov.querySelector('.elara-vmodal__close').addEventListener('click', close);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    document.addEventListener('keydown', onKey);
  }
  function assetBase() {
    var list = document.querySelectorAll('script[src*="/custom.js"]');
    var me = list[list.length - 1];
    return me ? me.src.split('custom.js')[0] : '';
  }
  function build(base) {
    var wrap = document.createElement('div');
    wrap.className = 'elara-vmarq';
    var track = document.createElement('div');
    track.className = 'elara-vmarq__track';
    var html = '';
    for (var rep = 0; rep < 2; rep++) {
      for (var i = 1; i <= N; i++) {
        html += '<div class="elara-vmarq__card"><video src="' + base + 'elara-ugc-' + i + '.mp4" muted loop autoplay playsinline preload="metadata"></video></div>';
      }
    }
    track.innerHTML = html;
    wrap.appendChild(track);
    var vids = wrap.querySelectorAll('video');
    for (var v = 0; v < vids.length; v++) {
      (function (vid) {
        vid.addEventListener('error', function () { if (vid.parentNode) vid.parentNode.style.display = 'none'; });
        vid.addEventListener('canplay', function () { var p = vid.play(); if (p && p.catch) p.catch(function(){}); });
      })(vids[v]);
    }
    var cards = wrap.querySelectorAll('.elara-vmarq__card');
    for (var c = 0; c < cards.length; c++) {
      (function (card) {
        card.addEventListener('click', function () { var v = card.querySelector('video'); openModal(v && v.getAttribute('src')); });
      })(cards[c]);
    }
    return wrap;
  }
  function inject() {
    if (document.querySelector('.elara-vmarq')) return true;
    var anchor = document.querySelector('.elara-marquee');
    if (!anchor) return false;
    var base = assetBase();
    if (!base) return false;
    anchor.insertAdjacentElement('afterend', build(base));
    return true;
  }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function () { if (!/\/products\//.test(location.pathname)) return; var n=0,t=setInterval(function(){ if(inject()||++n>60) clearInterval(t); },300); });
})();

/* Elara — three verified before/after review sliders under the UGC video conveyor.
   Drag the handle to wipe between before and after. Images are theme assets
   (elara-ba-<n>-before/after.jpg). Ratings 4.8 / 4.8 / 4.9. Product page only.
   These are real buyers' scalp-density before/afters — high ad-compliance risk;
   keep any paid creative off this pairing. Fill title/body when copy arrives. */
(function () {
  'use strict';
  function assetBase() {
    var list = document.querySelectorAll('script[src*="/custom.js"]');
    var me = list[list.length - 1];
    return me ? me.src.split('custom.js')[0] : '';
  }
  var REVIEWS3 = [
    { n: 1, title: "It looks fuller again", body: "I started noticing my hair wasn’t looking quite as full as it used to, especially when I styled it or put it up. I decided to give this brush a try and made it part of my routine. I really enjoy the scalp massage, and using it with my hair oil makes the whole process feel much easier. After staying consistent with it, I feel like my hair looks healthier and fuller, and I feel a lot better about the way it looks.", rating: 4.8 },
    { n: 2, title: "Full and put together", body: "For the longest time, I felt like my hair just looked flat and lacked the fullness it once had. I didn’t want to completely change my routine, so I started using this brush alongside the products I was already using. It’s so simple to use, and the massage is actually one of my favourite parts. Over time, I started feeling more confident with my hair and noticed that it looked much more full and put together.", rating: 4.8 },
    { n: 3, title: "The one I actually kept using", body: "I was honestly a little skeptical at first because I’ve bought so many hair-care products that ended up sitting unused. This one was different because it’s something I actually enjoy using. The brush feels great on my scalp, and I love being able to apply my oil without making a mess. After using it consistently as part of my routine, I started noticing my hair looked fuller and healthier, and I’ve definitely felt more confident when getting ready.", rating: 4.9 }
  ];
  function starsBlock(rating) {
    var pct = Math.max(0, Math.min(100, (rating / 5) * 100));
    var row = '<i>★</i><i>★</i><i>★</i><i>★</i><i>★</i>';
    return '<span class="elara-r3__stars">' +
             '<span class="elara-r3__tprow elara-r3__tprow--base">' + row + '</span>' +
             '<span class="elara-r3__fill" style="width:' + pct + '%"><span class="elara-r3__tprow elara-r3__tprow--on">' + row + '</span></span>' +
           '</span>';
  }
  function baBlock(base, n) {
    return '<div class="elara-ba" data-pos="50">' +
             '<img class="elara-ba__img elara-ba__after" src="' + base + 'elara-ba-' + n + '-after.jpg" alt="After" draggable="false">' +
             '<img class="elara-ba__img elara-ba__before" src="' + base + 'elara-ba-' + n + '-before.jpg" alt="Before" draggable="false">' +
             '<span class="elara-ba__tag elara-ba__tag--before">BEFORE</span>' +
             '<span class="elara-ba__tag elara-ba__tag--after">AFTER</span>' +
             '<div class="elara-ba__divider"><span class="elara-ba__handle">' +
               '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#A8394E" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="13 7 8 12 13 17"/><polyline points="11 7 16 12 11 17"/></svg>' +
             '</span></div>' +
           '</div>';
  }
  function card(base, r) {
    var el = document.createElement('article');
    el.className = 'elara-r3';
    el.innerHTML =
      baBlock(base, r.n) +
      '<h3 class="elara-r3__title">' + (r.title ? '“' + r.title + '”' : '') + '</h3>' +
      '<p class="elara-r3__label">Testimonial:</p>' +
      '<p class="elara-r3__body">' + (r.body ? '“' + r.body + '”' : '') + '</p>' +
      '<div class="elara-r3__tp"><span class="elara-r3__tp-star">★</span><span class="elara-r3__tp-word">Trustpilot</span>' + starsBlock(r.rating) + '</div>' +
      '<p class="elara-r3__count">' + r.rating.toFixed(1) + ' OUT OF 5 · VERIFIED ON TRUSTPILOT</p>';
    return el;
  }
  function setPos(ba, pos) {
    pos = Math.max(2, Math.min(98, pos));
    ba.setAttribute('data-pos', pos);
    var before = ba.querySelector('.elara-ba__before');
    var div = ba.querySelector('.elara-ba__divider');
    var clip = 'inset(0 ' + (100 - pos) + '% 0 0)';
    before.style.clipPath = clip;
    before.style.webkitClipPath = clip;
    div.style.left = pos + '%';
  }
  function initBA(ba) {
    setPos(ba, 50);
    var dragging = false;
    function posFromEvent(e) {
      var rect = ba.getBoundingClientRect();
      var cx = e.touches ? e.touches[0].clientX : e.clientX;
      return ((cx - rect.left) / rect.width) * 100;
    }
    function down(e) { dragging = true; setPos(ba, posFromEvent(e)); if (e.cancelable) e.preventDefault(); }
    function move(e) { if (!dragging) return; setPos(ba, posFromEvent(e)); if (e.cancelable) e.preventDefault(); }
    function up() { dragging = false; }
    ba.addEventListener('mousedown', down);
    ba.addEventListener('touchstart', down, { passive: false });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('mouseup', up);
    window.addEventListener('touchend', up);
  }
  function build(base) {
    var sec = document.createElement('section');
    sec.className = 'elara-r3wrap';
    var grid = document.createElement('div');
    grid.className = 'elara-r3grid';
    for (var i = 0; i < REVIEWS3.length; i++) grid.appendChild(card(base, REVIEWS3[i]));
    sec.appendChild(grid);
    return sec;
  }
  function inject() {
    if (document.querySelector('.elara-r3wrap')) return true;
    var anchor = document.querySelector('.elara-vmarq');
    if (!anchor) return false;
    var base = assetBase();
    if (!base) return false;
    var sec = build(base);
    anchor.insertAdjacentElement('afterend', sec);
    var bas = sec.querySelectorAll('.elara-ba');
    for (var i = 0; i < bas.length; i++) initBA(bas[i]);
    return true;
  }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function () { if (!/\/products\//.test(location.pathname)) return; var n=0,t=setInterval(function(){ if(inject()||++n>60) clearInterval(t); },300); });
})();

/* Elara — "in stock / sold" social-proof line under the Add to Cart button. */
(function () {
  'use strict';
  function build() {
    var el = document.createElement('div');
    el.className = 'elara-stock';
    el.innerHTML =
      '<span class="elara-stock__dot" aria-hidden="true"></span>' +
      '<span class="elara-stock__in">312 in stock</span>' +
      '<span class="elara-stock__sep">·</span>' +
      '<span class="elara-stock__sold">2688 sold</span>';
    return el;
  }
  function inject() {
    if (document.querySelector('.elara-stock')) return true;
    var anchor = document.querySelector('.buy-buttons-block') ||
                 (document.querySelector('.add-to-cart-button') || {}).closest &&
                 document.querySelector('.add-to-cart-button').closest('.product-form-buttons, form');
    if (!anchor) return false;
    anchor.insertAdjacentElement('afterend', build());
    return true;
  }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function () { var n=0,t=setInterval(function(){ if(inject()||++n>60) clearInterval(t); },300); });
})();

/* Elara — feature/callout infographic image, placed under the buy box & images,
   directly ABOVE the "Real hair, real results" marquee and the UGC conveyor. */
(function () {
  'use strict';
  function assetBase() {
    var list = document.querySelectorAll('script[src*="/custom.js"]');
    var me = list[list.length - 1];
    return me ? me.src.split('custom.js')[0] : '';
  }
  function inject() {
    if (document.querySelector('.elara-featwrap')) return true;
    var anchor = document.querySelector('.elara-marquee');
    if (!anchor) return false;
    var base = assetBase();
    if (!base) return false;
    var sec = document.createElement('section');
    sec.className = 'elara-featwrap';
    sec.innerHTML =
      '<img class="elara-featimg elara-featimg--desktop" src="' + base + 'elara-features.jpg?v=hq4" alt="What the Elara Red Light Brush does" loading="lazy">' +
      '<img class="elara-featimg elara-featimg--mobile" src="' + base + 'elara-features-mobile.jpg?v=hq5" alt="What the Elara Red Light Brush does" loading="lazy">';
    anchor.insertAdjacentElement('beforebegin', sec);
    return true;
  }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function () { if (!/\/products\//.test(location.pathname)) return; var n=0,t=setInterval(function(){ if(inject()||++n>60) clearInterval(t); },300); });
})();

/* Elara — "vs ordinary brush" comparison image, placed UNDER the bottom FAQ. */
(function () {
  'use strict';
  function assetBase() {
    var list = document.querySelectorAll('script[src*="/custom.js"]');
    var me = list[list.length - 1];
    return me ? me.src.split('custom.js')[0] : '';
  }
  function inject() {
    if (document.querySelector('.elara-comparewrap')) return true;
    var anchor = document.querySelector('.elara-faq2');
    if (!anchor) return false;
    var base = assetBase();
    if (!base) return false;
    var sec = document.createElement('section');
    sec.className = 'elara-comparewrap';
    sec.innerHTML =
      '<img class="elara-compareimg elara-compareimg--desktop" src="' + base + 'elara-compare.jpg?v=4" alt="Elara Red Light Brush vs an ordinary hairbrush" loading="lazy">' +
      '<img class="elara-compareimg elara-compareimg--mobile" src="' + base + 'elara-compare-mobile.jpg?v=2" alt="Elara Red Light Brush vs an ordinary hairbrush" loading="lazy">';
    anchor.insertAdjacentElement('afterend', sec);
    return true;
  }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function () { if (!/\/products\//.test(location.pathname)) return; var n=0,t=setInterval(function(){ if(inject()||++n>60) clearInterval(t); },300); });
})();
